// import React from 'react';
import {useState} from 'react';
import {useContext} from 'react';

// import styled from 'styled-components';
// import {Link} from 'react-router-dom';

import logoLampadaDj from '../../assets/images/logo_lampada_by_dj.svg';

import {UserContext} from '../../hooks/UserContext'
import ALink from '../../components/ALink'

import {
    Mnavbar,

    MnavbarV2,
    VoltarDiv,
    Logo,
    MenuDiv,

    Menu,
    SubMenu
} from './styled';

function MNAVBar(){
    // const {  } = props;
    // const ImgLampada = styled.div`
    // `;

    return (
        <Mnavbar className='mnavbar'>
          <img alt='Logo' title="Logo do inova maranhão, lâmpada amarela" src={logoLampadaDj}/>
        </Mnavbar>);
}

export default MNAVBar;

// const estrutura = {
//
// }

export function MHeaderV2({voltar}){
    // const {  } = props;
    // const ImgLampada = styled.div`
    // `;
    const [exibir,setExibir] = useState(false);

    return (
        <MnavbarV2 className='mnavbarV2' background='var(--noite-fundo3)' color="">
          <nav>
            <div className="mnavbarV2-menu">
              <VoltarBtn voltar={voltar}/>
              <Logo x={"21px"} y={"50px"} img={logoLampadaDj}/>
              <MenuBtn exibir={exibir} setExibir={setExibir}/>
            </div>
            <MenuCascata exibir={exibir}/>
          </nav>
          <div className="mnavbarV2-fundo"/>
        </MnavbarV2>
    );

}

function VoltarBtn({voltar}){

    return (
        <VoltarDiv>
          <div className={"btn"}>
            {!!voltar&&<i className="fi fi-rr-undo"  /*onClick = {()=>()}*/ />}
            { !voltar&&<i/>}
          </div>
        </VoltarDiv>
    )
}

function MenuBtn({exibir,setExibir}){

    return (
        <MenuDiv exibir={exibir}>
          <div className={exibir?"btn":"btn btn90"}>
            <i className="fi fi-rr-menu-burger"  onClick = {()=>(setExibir(x=>!x))}/>
          </div>
        </MenuDiv>
    )
}

function MenuCascata({exibir}){
    const { user } = useContext(UserContext);

    return (
        <Menu className="djsub-menuHV2" exibir={exibir}>
          <ul className="menu-cascata">
            <LiLink to={"/Planetas/"} text={"Missões"} />
            <Explore user={user}/>
            <Ferramentas user={user}/>
            <LiLink to={"/Duvidas"} text={"Tire dúvidas no ZAP"} />
            {/* <li className="adm-menu"/> */}
            {/* <Sair/> */}
            <LiLink to={"/Sair"} text={"Sair"} />
          </ul>
        </Menu>
    )
}


function Explore({user}) {
    const [estado,setEstado] = useState(true);

    const estrutura = [
        {
            to:"/sobre",
            text:"Sobre o Inova Maranhão e o Maratoninha Maker",
        },
        {
            to:"/Ranking",
            text:"RANKING",
        },
        {
            to:"/Cadastros",
            text:"Cadastros",
        },
    ]
    if (user)
        estrutura.push({ to:"/Certificados", text:"Certificados", className:"novo"})
    // if (user?.patente >= 3)
    //     estrutura.push({ to:"/dj/adm", text:"Resetar Senhas"})
    if (user?.patente >= 2)
        estrutura.push({ to:"/Supervisorio", text:"Supervisório"})

    return (<li className='-submenu'>
      <div onClick={()=>setEstado(x=>!x)} className="click">
        EXPLORE <i className={`fi-rr-angle-small-${estado ? "down" : "up"}`}/>
      </div>
      <SubMenu hide={estado}>
        {estrutura.map(
          (x,i)=> <LiLink
            to={x.to}
            text={x.text}
            className={x.className}
            key={`liLink_${i}_${x.text}`}
                  />
        )}
      </SubMenu>
    </li>)
}


function Ferramentas(/*{user}*/) {
    const [estado,setEstado] = useState(true);

    const estrutura = [
        {
            href:"http://wokwi.com",
            text:"Wokwi",
        },
        {
            href:"https://www.tinkercad.com/",
            text:"TinkerCAD",
        },
        {
            href:"http://create.arduino.cc/editor",
            text:"Arduino Editor",
        },
        {
            to:"/img/baixar/fritzing-548.64.pc.exe",
            text:"Fritizzing",
        },
        {
            href:"https://www.arduino.cc/en/software",
            text:"ArduinoIDE",
        },

    ]

    return (<li className='-submenu'>
      <div onClick={()=>setEstado(x=>!x)} className="click">
        Ferramentas <i className={`fi-rr-angle-small-${estado ? "down" : "up"}`}/>
      </div>
      <SubMenu hide={estado}>
        {estrutura.map(
          (x,i)=><LiLink
            to={x.to}
            href={x.href}
            text={x.text}
            className={x.className}
            key={`liLink_${i}_${x.text}`}
                 />
        )}
      </SubMenu>
    </li>)
}



function LiLink({to,href,text,className}){

    return <li><ALink className={`click ${className||""}`} href={href} to={to}>{text}</ALink></li>
      // if (!!href){
        //     return ( <li> <a target="_blank" rel="noreferrer" className={`click ${className||""}`} href={href}>{text}</a> </li> )
        // }
        // if (!!to){
        //     return ( <li> <Link className={`click ${className||""}`} to={to}>{text}</Link> </li> )
    // }
}
